import {CRS} from "leaflet";
import IGridOptions = uiGrid.expandable.IGridOptions;
import {IGridApi} from "ui-grid";
import {
    ExactCoordinateHelper,
    GpsCoordinateHelper,
    ICoordinateHelper,
    ReferencePoint
} from "../../libs/CoordinateHelper";
import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import {CmdCenterMapModel} from "../../models/cmd/CmdCenterMapModel";
import {ApplicationSetting} from "../../entities/ApplicationSetting";
import {Asset} from "../../entities/Asset";
import {FixedVTag} from "../../entities/FixedVTag";
import {Reader} from "../../entities/Reader";
import {LatLngZoom, MapDefaults} from "../../libs/LeafletHelper";
import L from "leaflet";
var moment = require('moment');
moment().format();

export class CmdCenterMapCtrl {
    tempSearch: string = "beep";
    static LOCALSTORAGE_CENTER: string = "LOCALSTORAGE_CENTER";
    static LOCALSTORAGE_LASTSITE: string = "LOCALSTORAGE_LASTSITE";
    static LOCALSTORAGE_LASTAREA: string = "LOCALSTORAGE_LASTAREA";
    static LOCALSTORAGE_MAP_PAGESIZE: string = "LOCALSTORAGE_MAP_PAGESIZE";
    defaults: MapDefaults = new MapDefaults(false, CRS.Simple, 5, -5);
    center: LatLngZoom = new LatLngZoom(0, 0, 1);
    layers:any = [];
    imageLayer: any = null;
    areaSelect: any = null;
    map: any;
    GRIDTYPEASSETTAGS: string = "Asset Tags";
    GRIDTYPFIXEDTAGS: string = "Fixed Tags";
    selectedGridType: string = this.GRIDTYPEASSETTAGS;
    gridOptionsAsset: any;
    gridOptionsFixed: any;
    pageSize: number = 50;
    page: number = 1;
    mapAssets: MapAsset[] = [];
    mapFixedTags: MapFixedVTag[] = [];
    mapGateways : MapGateway[] = [];
    mappedMapItems: MapItem[] = [];
    selectedMapSiteWatch: any;
    mapPageSizeWatch: any;
    selectedMapAreaWatch: any;
    selectedFilterWatch: any;
    exactCoordinateHelper: ExactCoordinateHelper;
    gpsCoordinateHelper: GpsCoordinateHelper;
    centerWatch: any;
    searchTextWatch: any;
    changedInterval: any;
    updateSearchTextInterval: any;
    updateIconsInterval: any;
    gridApiAsset: IGridApi;
    gridApiFixed: IGridApi;
    public static $inject = ['$window', '$q', '$scope', '$interval', '$state', '$stateParams', 'leafletData', '$uibModal', 'CmdCenterMapModel', 'localStorageService', 'NotificationService'];

    constructor(public $window: Window, public $q: ng.IQService, public $scope: any, public $interval: ng.IIntervalService, public stateService: StateService,
                public stateParamsService: StateParams,
                public leafletData: any, public modal: angular.ui.bootstrap.IModalService, public model: CmdCenterMapModel,
                public locStorage: angular.local.storage.ILocalStorageService, public notifyService: NotificationService) {
        console.log('CmdCenterMapCtrl.Init. default='+this.defaults.crs);
        $scope.vm = this;
        $scope.mapDefaults = new MapDefaults(false, CRS.Simple, 10, -5);
        this.gridOptionsAsset = {
            paginationPageSizes: [10, 15, 20, 50, 100, 200, 400, 600,1000],
            paginationPageSize: this.pageSize,
            useExternalPagination: false,
            useExternalSorting: false,
            columnDefs: [],
            data: [],
            onRegisterApi: function (gridApi:any) {
                $scope.vm.gridApiAsset = gridApi;
                gridApi.pagination.seek($scope.vm.page);
                gridApi.selection.on.rowSelectionChanged($scope, function (row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected) {
                        $scope.vm.model.addSelected(entity.asset);
                        entity.setSelected(true);
                    } else {
                        $scope.vm.model.removeSelected(entity.asset);
                        entity.setSelected(false);
                    }
                });
                gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows:any) {
                    $.each(rows, (i, row) => {
                        var entity = row.entity;
                        if (row.isSelected) {
                            $scope.vm.model.addSelected(entity.asset);
                            entity.setSelected(true);
                        } else {
                            $scope.vm.model.removeSelected(entity.asset);
                            entity.setSelected(false);
                        }
                    });
                });
                gridApi.pagination.on.paginationChanged($scope, function (newPage:any, pageSize:any) {
                    //alert(angular.element(document.getElementsByClassName('grid')[0]));
                    //$scope.vm.gridOptions.minRowsToShow = pageSize+1;
                    //$scope.vm.gridOptions.virtualizationThreshold = pageSize+1;
                    $scope.vm.page = newPage;
                    $scope.vm.pageSize = pageSize;
                    $scope.vm.updateMapTagsSmart();
                });
            }
        };
        this.gridOptionsFixed = {
            paginationPageSizes: [10, 15, 20, 50, 100, 200],
            paginationPageSize: this.pageSize,
            useExternalPagination: false,
            useExternalSorting: false,
            columnDefs: [
                {
                    name: ' ',
                    displayName: ' ',
                    enableSorting: false,
                    width: 35,
                    cellTemplate: '<div class="ngCellText ng-scope col2 colt2" ng-class="col.colIndex()"><button ng-disabled="row.entity.lng == null" class="btn btn-primary btn-xs" style="margin-top:5px;margin-left:5px;" stop-event="mousedown" ng-click="row.entity.swapExpanded($event)"><i class="glyphicon glyphicon-map-marker icon-white"></i></button></div>'
                },
                {field: 'fixedTag.name', name: 'Name', width: 150},
                {field: 'fixedTag.vTagID', name: 'V-Tag ID', width: 90},
                {field: 'fixedTag.locationName', name: 'Location Name', width: 140},
                {
                    field: 'fixedTag.vTagLastSeen',
                    name: 'Last Seen',
                    cellFilter: "date:'" + ApplicationSetting.applicationSetting.dateFormat + "'",
                    width: 190
                }
            ],
            data: [],
            onRegisterApi: function (gridApi:any) {
                $scope.vm.gridApiFixed = gridApi;
                gridApi.selection.on.rowSelectionChanged($scope, function (row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected) {
                        $scope.vm.model.addSelected(entity.fixedTag);
                        entity.setSelected(true);
                    } else {
                        $scope.vm.model.removeSelected(entity.fixedTag);
                        entity.setSelected(false);
                    }
                });
                gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows:any) {
                    $.each(rows, (i, row) => {
                        var entity = row.entity;
                        if (row.isSelected) {
                            $scope.vm.model.addSelected(entity.fixedTag);
                            entity.setSelected(true);
                        } else {
                            $scope.vm.model.removeSelected(entity.fixedTag);
                            entity.setSelected(false);
                        }
                    });
                });
            }
        };
        $scope.$on('$destroy', () => {
            // console.log("cmdcentermapctrl destroy!! **************")
            this.removeWatches();
            if (this.changedInterval != null)
                this.$interval.cancel(this.changedInterval);
            if (this.updateIconsInterval != null)
                this.$interval.cancel(this.updateIconsInterval);
        })
        var lastSiteId = this.locStorage.get<number>(CmdCenterMapCtrl.LOCALSTORAGE_LASTSITE);
        var lastAreaId = this.locStorage.get<number>(CmdCenterMapCtrl.LOCALSTORAGE_LASTAREA);
        var mapPageSize = this.locStorage.get<number>(CmdCenterMapCtrl.LOCALSTORAGE_MAP_PAGESIZE);
        if(mapPageSize !== null) {
            this.pageSize = mapPageSize;
            this.gridOptionsAsset.paginationPageSize = mapPageSize;
        }
        this.model.init(lastSiteId, lastAreaId).then((ok) => {
            MapAsset.activeMinutes = this.model.activeTimeout;
            this.gridOptionsAsset.columnDefs = this.setColumns();
            // console.log("ctrl model.inet getCurr");
            if (this.model.selectedMapArea == null) {
                this.notifyService.notifyError("No Map Area is defined.");
                return;
            }
            this.exactCoordinateHelper = new ExactCoordinateHelper(this.model.selectedMapArea.pixelsPerMeter, this.model.vTagPositionReportingMode,ApplicationSetting.applicationSetting.cmdMapPinZoominEnabled,ApplicationSetting.applicationSetting.cmdMapPinDisplacePixels);
            this.gpsCoordinateHelper = new GpsCoordinateHelper(
                new ReferencePoint(this.model.selectedMapArea.geo1Longitude, this.model.selectedMapArea.geo1Latitude, 300, this.model.selectedMapArea.geo1PixelsX, this.model.selectedMapArea.geo1PixelsY),
                new ReferencePoint(this.model.selectedMapArea.geo2Longitude, this.model.selectedMapArea.geo2Latitude, 300, this.model.selectedMapArea.geo2PixelsX, this.model.selectedMapArea.geo2PixelsY),
                this.model.selectedMapArea.pixelsPerMeter);
            this.model.getCurrentTags();
            this.updateMapTagsSmart();
            this.model.selectedItems = [];
            this.updateIconsInterval = this.$interval(() => {
                this.updateIcons();
            }, 300000);
            this.updateSearchTextInterval = this.$interval(() => {
                this.updateSearchText();
            }, 1000);
            this.changedInterval = this.$interval(() => {
                this.getChanged();
            }, this.model.mapRefresh * 1000);
            this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_LASTSITE, this.model.selectedMapSite.id);
            this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_LASTAREA, this.model.selectedMapArea.id);
            this.addWatches();
            this.getCenter();
            var mapPromise = leafletData.getMap("mainMap");
            return mapPromise;
        }).then((map) => {
            // console.log("got map");
            this.map = map;
            this.mapAreaChanged(this.model.selectedMapArea, null);
            //this.setImage();
            $scope.$on('leafletDirectiveMarker.mainMap.contextmenu', (evt:any, args:any) => {
                var mapItem = args.model;
                var selectedIndex = args.modelName;
                var id = this.mappedMapItems[selectedIndex].id;
                var mapFixedTag = null;
                var mapAsset = null;
                // console.log("Test id = " + id);
                for (var i = 0; i < this.mapFixedTags.length; i++) {
                    if (this.mapFixedTags[i].id == id && mapItem.fixedTag != null) {
                        mapFixedTag = this.mapFixedTags[i];
                        break;
                    }
                }
                for (var i = 0; i < this.mapAssets.length; i++) {
                    if (this.mapAssets[i].id == id && mapItem.asset != null) {
                        mapAsset = this.mapAssets[i];
                        break;
                    }
                }
                if (mapFixedTag != null) {
                    this.showNearest(mapFixedTag.fixedTag.vTagID);
                }
                if (mapAsset != null && mapAsset.asset.latitude != null) {
                    this.showGoogleMaps(mapAsset.asset.latitude, mapAsset.asset.longitude)
                }
            });
            //var drawnItems = $scope.controls.draw.edit.featureGroup;
            //L.control.mousePosition().addTo(map);
            var fscreen = L.control.fullscreen({position:'topleft'});
            //this.map.addControl(fscreen);
        });
        console.log('CmdCenterMapCtrl.Init.Done');
    }

    showGoogleMaps(latitude: number, longitude: number) {
        this.$window.open('https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude, '_blank');
    }

    showNearest(vtagId: string) {
        // console.log("show dialog now");
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/cmdcenter.shownearest.html').default,
            controller: 'CmdCenterShowNearestCtrl',
            resolve: {
                vtagId: function () {
                    return vtagId;
                }
            }
        });
        modalInstance.result.then((asset) => {
        });
    }

    updateIcons() {
        $.each(this.mapAssets, (index, asset: MapAsset) => {
            asset.updateIcon();
        });
        $.each(this.mapFixedTags, (index, asset: MapFixedVTag) => {
            asset.updateIcon();
        });
        $.each(this.mapGateways, (index, gateway: MapGateway) => {
            gateway.updateIcon();
        });
    }

    // Angular markers directive discards marker changes which happen in a 10 ms window
    // So the search text is updated at 1 second intervals to generate 1 second events
    updateSearchText() {
        if (this.model.rawSearchText !== this.model.searchText) {
            this.model.searchText = this.model.rawSearchText;
        }
    }

    getChanged() {
        var nextRefresh: number = this.model.mapRefresh * 1000;
        var lastCheckedChangedStr = this.model.lastCheckedChanged.toUTCString();
        this.model.lastCheckedChanged = new Date();
        // console.log("calling getChanged with "+lastCheckedChangedStr+", now="+this.model.lastCheckedChanged.toUTCString());
        // console.log("get changed "+nextRefresh);
        this.$q.all([this.model.getChangedAssets(lastCheckedChangedStr),
                this.model.getChangedFixedTags(lastCheckedChangedStr),
                this.model.getChangedGateways(lastCheckedChangedStr)]).then(() => {
            this.updateMapTagsSmart();
        });
    }

    getCenter(): void {
        if (this.model.selectedMapArea != null) {
            var centerStr = this.locStorage.get<string>(CmdCenterMapCtrl.LOCALSTORAGE_CENTER + "_" + this.model.selectedMapArea.id);
            // console.log("retrieving center "+centerStr+" <----- for id "+CmdCenterMapCtrl.LOCALSTORAGE_CENTER + "_" + this.model.selectedMapArea.id);
            if (centerStr == null)
                this.center = new LatLngZoom(0, 0, 1);
            else
                this.center = JSON.parse(centerStr);
        }
    }

    mapAreaChanged(newVal:any, oldVal:any) {
        if (oldVal != newVal) {
            this.exactCoordinateHelper = new ExactCoordinateHelper(newVal.pixelsPerMeter, this.model.vTagPositionReportingMode,
                ApplicationSetting.applicationSetting.cmdMapPinZoominEnabled,ApplicationSetting.applicationSetting.cmdMapPinDisplacePixels);
            this.gpsCoordinateHelper = new GpsCoordinateHelper(
                new ReferencePoint(newVal.geo1Longitude, newVal.geo1Latitude, 300, newVal.geo1PixelsX, newVal.geo1PixelsY),
                new ReferencePoint(newVal.geo2Longitude, newVal.geo2Latitude, 300, newVal.geo2PixelsX, newVal.geo2PixelsY),
                newVal.pixelsPerMeter);
            // console.log("selMA watch");
            this.model.getCurrentTags();
            this.updateMapTagsSmart();
            this.model.selectedItems = [];
            this.getCenter();
            this.setImage();
            this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_LASTAREA, this.model.selectedMapArea.id);
        }
    }

    addWatches() {

        this.selectedMapSiteWatch = this.$scope.$watch(() => this.model.selectedMapSite, (newVal:any, oldVal:any) => {
            var uuuuhuhuhuhuh = 3;
            // console.log(    "SELECTED MAP SITE CHANGED!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
            if (oldVal != newVal) {
                this.$q.all([this.model.getAssets(), this.model.getFixedTags()]).then(() => {
                    this.model.setMapAreas();
                    this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_LASTSITE, this.model.selectedMapSite.id);
                }).catch((data: any) => {
                    var error = data;
                    //handle error
                    alert("got error in getting tags for site: " + data);
                });
            }
        });
        this.selectedMapAreaWatch = this.$scope.$watch(() => this.model.selectedMapArea, (newVal:any, oldVal:any) => {
            this.mapAreaChanged(newVal, oldVal);
        });
        this.mapPageSizeWatch = this.$scope.$watch(() => this.pageSize, (newVal:any, oldVal:any) => {
            this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_MAP_PAGESIZE, this.pageSize);
        });
        this.searchTextWatch = this.$scope.$watch(() => this.model.searchText, (newVal:any, oldVal:any) => {
            if (oldVal != newVal) {
                this.model.getCurrentTags();
                this.updateMapTagsSmart();
            }
        });
        this.selectedFilterWatch = this.$scope.$watch(() => this.model.selectedFilter, (newVal:any, oldVal:any) => {
            if (oldVal != newVal) {
                this.model.getCurrentTags();
                this.updateMapTagsSmart();
                if (newVal.indexOf("Fixed") != -1)
                    this.selectedGridType = this.GRIDTYPFIXEDTAGS;
                else
                    this.selectedGridType = this.GRIDTYPEASSETTAGS;
            }
        });
        this.centerWatch = this.$scope.$watch(() => this.center, (newVal:any, oldVal:any) => {
            if (oldVal != newVal) {
                if (this.model.selectedMapArea != null) {
                    var centerStr = JSON.stringify(this.center);
                    this.locStorage.set(CmdCenterMapCtrl.LOCALSTORAGE_CENTER + "_" + this.model.selectedMapArea.id, centerStr);
                    this.updateMapTagsSmart();
                }
            }
        }, true);
    }

    removeWatches() {
        if (this.selectedMapSiteWatch != null) {
            this.selectedMapSiteWatch();
            this.selectedMapAreaWatch();
            this.searchTextWatch();
            this.selectedFilterWatch();
            this.selectedMapSiteWatch = null;
            this.selectedMapAreaWatch = null;
            this.searchTextWatch = null;
            this.selectedFilterWatch = null;
        }
    }

    setImage() {
        if (this.imageLayer != null) {
            this.map.removeLayer(this.imageLayer);
        }
        if (this.model.selectedMapArea == null)
            return;
        this.model.getMapAreaImage().then((ok) => {
            var fdid = this.model.selectedMapArea.fileDataID;
            var height = this.model.selectedMapArea.imageHeight;
            var width = this.model.selectedMapArea.imageWidth;
            var imgUrl = "data:image/png;base64," + this.model.imageData;
            this.imageLayer = L.imageOverlay(imgUrl, [[0, 0], [-1 * height, width]]).addTo(this.map);
            //this.imageLayer = L.imageOverlay(this.model.getBaseUrl()+"/getImage?id="+fdid, [[0,0],[-1*height,width]]).addTo(this.map);
            this.imageLayer.bringToBack();
        });
    }

    updateMapTagsSmart():void {
        //first find any tags with expanded marker (focus)
        var expandedAsset: MapAsset = null;
        var expandedFixed: MapFixedVTag = null;
        //get expanded items
        for(var i=0; i< this.mapAssets.length; i++){
            var mapAsset = this.mapAssets[i];
            if (mapAsset.focus == true) {
                expandedAsset = mapAsset;
                break;
            }
        }
        for(var i=0; i< this.mapFixedTags.length; i++){
            var mapFixed = this.mapFixedTags[i];
            if (mapFixed.focus == true) {
                expandedFixed = mapFixed;
                break;
            }
        }
        var selectedMapAssets: number[] = [];
        var selectedMapFixed: number[] = [];
        //get selected lists
        $.each(this.mapAssets, (i, mapAsset: MapAsset) => {
            if (mapAsset.selected)
                selectedMapAssets.push(mapAsset.asset.id);
        });
        $.each(this.mapFixedTags, (i, mapFixed: MapFixedVTag) => {
            if (mapFixed.selected)
                selectedMapFixed.push(mapFixed.fixedTag.id);
        });
        //finally redo everything and reset focus/expanded
        this.mapAssets.length = 0;
        this.mapFixedTags.length = 0;
        this.mapGateways.length = 0;
        this.mappedMapItems = [];
        this.model.selectedItems = [];
        var selectedMapAssetIndexes: number[] = [];
        var selectedFixedMapIndexes: number[] = [];
        let startIndex = (this.page-1)*this.pageSize;
        let endIndex = this.page*this.pageSize-1;
        for (var i = 0; i < this.model.currentAssets.length; i++) {
            //console.log("current asset "+this.model.currentAssets[i].name+". i="+i);
            //console.log("updateMapTags.assets - "+this.model.currentAssets[i].vTagID+", selectedMapArea="+this.model.selectedMapArea.name+", and ppm ="+this.model.selectedMapArea.pixelsPerMeter);
            var coorHelper: ICoordinateHelper = this.model.currentAssets[i].vTagType == "VTag GPS" ? this.gpsCoordinateHelper : this.exactCoordinateHelper;
            var mapAsset = new MapAsset(this.model.currentAssets[i], coorHelper, this.model.selectedMapArea.pixelsPerMeter, this.model.vtagColumnDefs, this.center.zoom);
            for(var j=0; j< selectedMapAssets.length; j++){
                var tempMapAsset = selectedMapAssets[j];
                if (tempMapAsset == mapAsset.asset.id) {
                    selectedMapAssetIndexes.push(i);
                    mapAsset.selected = true;
                    break;
                }
            }
            if (expandedAsset != null && expandedAsset.asset.id == mapAsset.asset.id) {
                // console.log("expanding mapAsset "+expandedAsset.asset.name);
                mapAsset.focus = true;
            }
            this.mapAssets.push(mapAsset);
            if (this.model.currentAssets[i].hasVTagData() && mapAsset.mapCoorOk() && i >= startIndex && i <=endIndex) {
                //console.log("adding asset to map: "+this.model.currentAssets[i].name+" with lat:"+mapAsset.lat+" and lng:"+mapAsset.lng);
                this.mappedMapItems.push(mapAsset);
            } else {
                // console.log("*****&*&*&*&*&*&  this vtag has no vtag data:"+this.model.currentAssets[i].name);
            }
        }
        for (var i = 0; i < this.model.currentFixedTags.length; i++) {
            var mapFixedTag: MapFixedVTag = new MapFixedVTag(this.model.currentFixedTags[i], this.model.selectedMapArea.pixelsPerMeter);
            for(var j=0; j<selectedMapFixed.length; j++){
                var tempMapFixed = selectedMapFixed[j];
                if (tempMapFixed == mapFixedTag.fixedTag.id) {
                    selectedFixedMapIndexes.push(i);
                    mapFixedTag.selected = true;
                    break;
                }
            }
            if (expandedFixed != null && expandedFixed.fixedTag.id == mapFixedTag.fixedTag.id)
                mapFixedTag.focus = true;
            // console.log("updateMapTags.fixed - "+this.model.currentFixedTags[i].vTagID);
            this.mapFixedTags.push(mapFixedTag);
            if (mapFixedTag.mapCoorOk()) {
                // console.log("adding fixed tag to map: "+mapFixedTag.fixedTag.name+" with lat:"+mapFixedTag.lat+" and lng:"+mapFixedTag.lng);
                this.mappedMapItems.push(mapFixedTag);
            } else {
                // console.log("*****&*&*&*&*&*&  this vtag has no vtag data:" + mapFixedTag.fixedTag.vTagID);
            }
        }
        for (var i = 0; i < this.model.currentGateways.length; i++) {
            var mapGateway: MapGateway = new MapGateway(this.model.currentGateways[i], this.model.selectedMapArea.pixelsPerMeter);
            this.mapGateways.push(mapGateway);
            if (mapGateway.mapCoorOk()) {
                // console.log("adding fixed tag to map: "+mapFixedTag.fixedTag.name+" with lat:"+mapFixedTag.lat+" and lng:"+mapFixedTag.lng);
                this.mappedMapItems.push(mapGateway);
            } else {
                // console.log("*****&*&*&*&*&*&  this vtag has no vtag data:" + mapFixedTag.fixedTag.vTagID);
            }
        }
        this.gridOptionsAsset.data = this.mapAssets;
        this.gridOptionsFixed.data = this.mapFixedTags;
        this.gridApiAsset.grid.modifyRows(this.gridOptionsAsset.data);
        this.gridApiFixed.grid.modifyRows(this.gridOptionsFixed.data);
        $.each(selectedMapAssetIndexes, (i, tempIndex: number) => {
            var mapAsset = this.mapAssets[tempIndex];
            this.gridApiAsset.selection.selectRow(mapAsset);
        });
        $.each(selectedFixedMapIndexes, (i, tempIndex: number) => {
            var mapFixed = this.mapFixedTags[tempIndex];
            this.gridApiFixed.selection.selectRow(mapFixed);
        });
        // console.log("");
        // console.log("");
    }

    locate(): void {
        this.removeWatches();
        this.model.locateAdv().then((vtag) => {
            //at this point the mapsite and maparea have been correctly set
            //do we need to wait until the selectedMapArea watch has been triggered? if so, timeout. if not...
            //center map on the asset in question and then show info box.
            // console.log("locate.getCurr");
            this.exactCoordinateHelper = new ExactCoordinateHelper(this.model.selectedMapArea.pixelsPerMeter, this.model.vTagPositionReportingMode,ApplicationSetting.applicationSetting.cmdMapPinZoominEnabled,ApplicationSetting.applicationSetting.cmdMapPinDisplacePixels);
            this.gpsCoordinateHelper = new GpsCoordinateHelper(
                new ReferencePoint(this.model.selectedMapArea.geo1Longitude, this.model.selectedMapArea.geo1Latitude, 300, this.model.selectedMapArea.geo1PixelsX, this.model.selectedMapArea.geo1PixelsY),
                new ReferencePoint(this.model.selectedMapArea.geo2Longitude, this.model.selectedMapArea.geo2Latitude, 300, this.model.selectedMapArea.geo2PixelsX, this.model.selectedMapArea.geo2PixelsY),
                this.model.selectedMapArea.pixelsPerMeter);
            this.$q.all([this.model.getAssets(), this.model.getFixedTags()]).then(() => {
                this.model.getCurrentTags();
                this.updateMapTagsSmart();
                this.model.selectedItems = [];
                this.setImage();
                var mapItem: MapItem;
                for (var i = 0; i < this.mapFixedTags.length; i++ && mapItem != null) {
                    if (this.mapFixedTags[i].fixedTag.vTagID === vtag.vTagID) {
                        mapItem = this.mapFixedTags[i];
                    }
                }
                for (var i = 0; i < this.mapAssets.length; i++ && mapItem != null) {
                    if (this.mapAssets[i].asset.vTagID === vtag.vTagID) {
                        mapItem = this.mapAssets[i];
                    }
                }
                if (mapItem != null) {
                    this.map.panTo(new L.LatLng(mapItem.lat, mapItem.lng));
                    mapItem.focus = true;
                }
                this.addWatches();
            });
        });
    }

    controls = {
        //draw: {}
    };

    setColumns(): any {
        var cols: any = [];
        var dateFilter = ApplicationSetting.applicationSetting.dateFormat;
        cols.push({
            name: ' ',
            displayName: ' ',
            enableSorting: false,
            width: 35,
            cellTemplate: '<div class="ngCellText ng-scope col2 colt2" ng-class="col.colIndex()"><button ng-disabled="row.entity.lng == null" class="btn btn-primary btn-xs" style="margin-top:5px;margin-left:5px;" stop-event="mousedown" ng-click="row.entity.swapExpanded($event)"><i class="glyphicon glyphicon-map-marker icon-white"></i></button></div>'
        });
        //cols.push({ field: "beep", name:"beeper", width:125, enableSorting:true});
        $.each(this.model.assetColumnDefs, (index, nv) => {
            if (nv[0] == "created" || nv[0] == "vTagLastSeen" || nv[0] == "lastGPSFix" || nv[0] == "vTagLastMoved" || nv[0] == "lastModified" || nv[0] == "timeseen" || nv[0] == "lastObservedTime" || nv[0] == "eventTime" || nv[0] == "alarmTime" || nv[0] == "lastAttempt" || nv[0] == "ackTime" || nv[0] == "nextMaintenance" || nv[0] == "lastMaintenance") {
                cols.push({
                    field: "asset." + nv[0],
                    name: nv[1],
                    displayName: nv[1],
                    width: nv[2],
                    cellFilter: "date:'" + dateFilter + "'",
                    enableSorting: true,
                });
            } else
                cols.push({
                    field: "asset." + nv[0],
                    name: nv[1],
                    displayName: nv[1],
                    width: 125,
                    enableSorting: true
                });
        })
        return cols;
    }

}

export interface MapItem {
    lat: number;
    lng: number;
    id: number;
    message: string;//"<div ng-include src=\"'partials/mapAsset.html'\"></div>";
    focus: boolean;
    selected: boolean;
    draggable: boolean;
    scope: any;
    icon: MapIcon;
}

export class MapAsset implements MapItem {
    lat: number;
    lng: number;
    id: number;
    message: string = "";//"<div ng-include src=\"'partials/mapAsset.html'\"></div>";
    focus: boolean = false;
    selected: boolean = false;
    draggable: boolean = false;
    zIndexOffset: number = 2000;
    scope: any;
    icon: MapIcon = new MapIcon();
    static activeMinutes: number = 60;

    constructor(public asset: Asset, public coordinateHelper: ICoordinateHelper, public ppm: number, public displayColumns: [string, string, number][],
                public zoomLevel: number) {
        this.id = asset.id;
        this.setMessage();
        this.updateLocation();
        this.updateIcon();
    }

    swapExpanded(evt:any) {
        this.focus = this.focus ? false : true;
    }

    mapCoorOk(): boolean {
        if (this.lng == null || this.lat == null || isNaN(this.lng) || isNaN(this.lat))
            return false;
        else
            return true;
    }

    setMessage() {
        this.message = "<table>";
        if (this.asset.fileDataID !== null) {
            this.message += "<tr><td style='padding-right:30px'><b><a target='_blank' rel='noopener noreferrer' href='/#!/admin/assetpicture/" + this.asset.fileDataID+"'>View Image</a></b></td>" + "<td style='padding - right: 30px'></td></tr>";
        }
        var dateFormat = ApplicationSetting.applicationSetting.dateFormat.replace("dd", "DD").replace("yyyy", "YYYY");
        var justDate = dateFormat.replace("HH:mm:ss", "").replace("hh:mm:ss a", "").replace("hh:mm:ss", "");
        for (var i = 0; i < this.displayColumns.length; i++) {
            var dc = this.displayColumns[i];
            var val = this.getColumnDisplayValue(dc[0]);
            if(dc[0] == "created" || dc[0] == "vTagLastSeen" || dc[0] == "lastGPSFix" || dc[0] == "vTagLastMoved" || dc[0] == "lastModified" || dc[0] == "timeseen" || dc[0] == "lastObservedTime" || dc[0] == "eventTime" || dc[0] == "alarmTime" || dc[0] == "lastAttempt" || dc[0] == "ackTime" || dc[0] == "nextMaintenance" || dc[0] == "lastMaintenance")
                val = moment(val).format(dateFormat);
            else if (dc[0] == "date1" || dc[0] == "date2" || dc[0] == "date3" || dc[0] == "date4" || dc[0] == "date5")
                val = moment(val).format(justDate);
            this.message += "<tr><td style='padding-right:30px'><b>" + dc[1] + "</b></td>" + "<td style='padding-right:30px'>" + val + "</td></tr>";
        }
        this.message += "</table>";
    }

    getColumnDisplayValue(fieldname: string) {
        var asdf:any = this.asset;
        var displayValue = (<any>this.asset)[fieldname];
        // console.log("GETCOLUMNDISPLAYVALUE fieldname="+fieldname+" and displayVal="+displayValue);
        return displayValue == null ? " " : displayValue;
    }

    setSelected(sel: boolean) {
        this.selected = sel;
        this.updateIcon();
    }

    updateLocation() {
        var vector = this.coordinateHelper.getCanvasPoint(this.asset, this.zoomLevel);
        this.lat = vector.Y;
        this.lng = vector.X;
    }

    updateIcon() {
        this.icon.icon = "star";
        if (this.selected)
            this.icon.markerColor = "blue";
        else if (this.asset.isRecentlyActive()) {
            this.icon.markerColor = "orange";// "#00EECF";
            // console.log("mapAsset "+this.asset.vTagID+" coler cyan");
        } else if (this.asset.isActiveTag(MapAsset.activeMinutes)) {
            this.icon.markerColor = "green";
            if (this.asset.vTagType === "VTag GPS" && this.asset.missedSatelliteFixes > 0) {
                this.icon.markerColor = "lightgreen";
            }
            // console.log("mapAsset "+this.asset.vTagID+" coler green");
        } else {
            this.icon.markerColor = "red";
            // console.log("mapAsset "+this.asset.vTagID+" coler red");
        }
        var a34234oeu = 3;
    }
}

export class MapFixedVTag implements MapItem {
    lat: number;
    lng: number;
    id: number;
    message: string = "";//"<div ng-include src=\"'partials/mapAsset.html'\"></div>";
    focus: boolean = false;
    selected: boolean = false;
    draggable: boolean = false;
    scope: any;
    icon: MapIcon = new MapIcon();
    zIndexOffset: number = 20;

    constructor(public fixedTag: FixedVTag, public ppm: number) {
        this.id = fixedTag.id;
        this.setMessage();
        this.updateLocation();
        this.updateIcon();
    }

    mapCoorOk() {
        if (this.lat == null || this.lng == null)
            return false;
        else
            return true;
    }

    swapExpanded(evt:any) {
        this.focus = this.focus ? false : true;
    }

    setMessage() {
        var batteryLevel = this.fixedTag.batteryLevel == null ? "" : this.fixedTag.batteryLevel;
        var dateFormat = ApplicationSetting.applicationSetting.dateFormat.replace("dd", "DD").replace("yyyy", "YYYY");
        var lastSeen = this.fixedTag.vTagLastSeen == null ? "" : moment(this.fixedTag.vTagLastSeen).format(dateFormat);
        var location = this.fixedTag.locationName == null ? "" : this.fixedTag.locationName;
        this.message = "<table>" +
            "<tr><td style='padding-right:30px;'><b>Tag ID</b></td>" + "<td style='padding-right:30px'>" + this.fixedTag.vTagID + "</td></tr>" +
            "<tr><td style='padding-right:30px;'><b>Name</b></td>" + "<td style='padding-right:30px'>" + this.fixedTag.name + "</td></tr>" +
            "<tr><td style='padding-right:30px;'><b>Location</b></td>" + "<td style='padding-right:30px'>" + location + "</td></tr>" +
            "<tr><td style='padding-right:30px;'><b>Last Seen</b></td>" + "<td style='padding-right:30px'>" + lastSeen + "</td></tr>" +
            "<tr><td style='padding-right:30px;'><b>Battery Level</b></td>" + "<td style='padding-right:30px'>" + batteryLevel + "</td></tr>";
        this.message += "</table>";
    }

    setSelected(sel: boolean) {
        this.selected = sel;
        this.updateIcon();
    }

    updateLocation() {
        // console.log("updateLocation for fixed tag "+this.fixedTag.vTagID);
        if (this.fixedTag.vTagX != null) {
            this.lng = this.fixedTag.vTagX * this.ppm;
            // console.log(("fixedTag.lng="+this.lng+", vTagX="+this.fixedTag.vTagX+",ppm="+this.ppm));
        }
        if (this.fixedTag.vTagY != null) {
            this.lat = this.fixedTag.vTagY * this.ppm;
            // console.log(("fixedTag.lat="+this.lat+", vTagY="+this.fixedTag.vTagY+",ppm="+this.ppm));
        }
    }

    updateIcon() {
        this.icon.icon = "home";
        if (this.selected)
            this.icon.markerColor = "blue";
        else if (this.fixedTag.isActiveTag(MapAsset.activeMinutes))
            this.icon.markerColor = "green";
        else
            this.icon.markerColor = "red";
    }
}

export class MapGateway implements MapItem {
    lat: number;
    lng: number;
    id: number;
    message: string = "";
    focus: boolean = false;
    selected: boolean = false;
    draggable: boolean = false;
    scope: any;
    icon: MapIcon = new MapIcon();
    zIndexOffset: number = 20;

    constructor(public gateway: Reader, public ppm: number) {
        this.id = gateway.id;
        this.setMessage();
        this.updateLocation();
        this.updateIcon();
    }

    mapCoorOk() {
        if (this.lat == null || this.lng == null)
            return false;
        else
            return true;
    }

    updateLocation() {
        if (this.gateway.vTagX != null) {
            this.lng = this.gateway.vTagX * this.ppm;
        }
        if (this.gateway.vTagY != null) {
            this.lat = this.gateway.vTagY * this.ppm;
        }
    }

    setMessage() {
        this.message = "<table>" +
            "<tr><td style='padding-right:30px;'><b>Name</b></td>" + "<td style='padding-right:30px'>" + this.gateway.name + "</td></tr>";
        this.message += "</table>";
    }

    updateIcon() {
        this.icon.icon = "sort";
        if (this.gateway.isActive(MapAsset.activeMinutes))
            this.icon.markerColor = "green";
        else
            this.icon.markerColor = "red";
    }
}

export class MapIcon {
    type: string = "awesomeMarker";
    icon: string = "adn";
    markerColor: string = "red";

    constructor() {
    }
}
